import i18n  from "i18n";

export const filterTypeMap = {
  type: { name: "type", type: "dropdown" },
  mem_epc: { name: "mem_epc", type: "dropdown" },
  mem_user: { name: "mem_user", type: "dropdown" }
};

export const filterData = [
  {
    type: "dropdown",
    label: i18n.t("packaging.type"),
    firstOptionLabel: i18n.t("all.types"),
    options: [
      {
        label: i18n.t("box"),
        selected: "false",
        id: "BOX",
        type: "type"
      },
      {
        label: i18n.t("product"),
        selected: "false",
        id: "PRODUCT",
        type: "type"
      },
      {
        label: i18n.t("pallet"),
        selected: "false",
        id: "PALLET",
        type: "type"
      }
    ],
    name: "type"
  },
  {
    type: "dropdown",
    label: i18n.t("epc.memory"),
    firstOptionLabel: i18n.t("all.m"),
    options: [
      {
        label: "96GB",
        selected: "false",
        id: "96",
        type: "mem_epc"
      },
      {
        label: "128GB",
        selected: "false",
        id: "128",
        type: "mem_epc"
      },
      {
        label: "240GB",
        selected: "false",
        id: "240",
        type: "mem_epc"
      }
    ],
    name: "mem_epc"
  },
  {
    type: "dropdown",
    label: i18n.t("user.memory"),
    firstOptionLabel: i18n.t("all.m"),
    options: [
      {
        label: "32GB",
        selected: "false",
        id: "32",
        type: "mem_user"
      },
      {
        label: "64GB",
        selected: "false",
        id: "64",
        type: "mem_user"
      }
    ],
    name: "mem_user"
  }
];
